var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"value":_vm.fieldData.value,"clearable":""},on:{"on-change":_vm.selectChange}},_vm._l((_vm.list),function(item,index){return _c('Option',{key:index,attrs:{"value":item.value}},[_vm._v(_vm._s(item.label))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }